Variable tab